import { Box, Button, Checkbox, FormControlLabel, IconButton, InputAdornment, Select, Tab, Tabs, TextField, Typography, BaseTextFieldProps, MenuItem, } from '@mui/material'
import React, { useState } from 'react'
import { fb, linkdin, Logo, mail, microsoft, } from '../../assets/images'
import { RightArrow } from '../../assets/icons'
import Grid from '@mui/material/Grid2'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import umbrellaSignBg from "../../assets/images/umbrellaSignBg.png"
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import { CheckboxProps } from '@mui/material/Checkbox';
import 'react-international-phone/style.css';
import { CountryIso2, defaultCountries, FlagImage, parseCountry, usePhoneInput, } from 'react-international-phone';


interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export interface MUIPhoneProps extends BaseTextFieldProps {
    value: string;
    onChange: (phone: string) => void;
}

export const MuiPhone: React.FC<MUIPhoneProps> = ({
    value,
    onChange,
    ...restProps
}) => {
    const { inputValue, handlePhoneValueChange, inputRef, country, setCountry } =
        usePhoneInput({
            defaultCountry: 'us',
            value,
            countries: defaultCountries,
            onChange: (data) => {
                onChange(data.phone);
            },
        });

    return (
        <TextField
            variant="outlined"
            label="Phone number"
            color="primary"
            placeholder="Phone number"
            value={inputValue}
            onChange={handlePhoneValueChange}
            type="tel"
            inputRef={inputRef}
            sx={{
                "& .MuiOutlinedInput-root": {
                    borderRadius: '3px',
                    borderColor: '#666666',
                },

                " .MuiInputLabel-root.Mui-focused": {
                    color: "inherit",
                },

                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: '#333333',
                    border: '1px solid'
                },

                "& .MuiOutlinedInput-input": {
                    padding: '14px 16px',
                    background: '#ffffff',
                    borderRadius: '8px'
                },
                "&.MuiInputBase-input::placeholder": {
                    color: '#333333',
                    fontSize: '16px',
                    opacity: '0.8'
                },
            }}

            slotProps={{
                input: {
                    startAdornment: <InputAdornment
                        position="start"
                        style={{ marginRight: '2px', marginLeft: '-8px' }}
                    >
                        <Select
                            MenuProps={{
                                style: {
                                    height: '300px',
                                    width: '360px',
                                    top: '10px',
                                    left: '-34px',
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left',
                                },
                            }}
                            sx={{
                                width: 'max-content',
                                fieldset: {
                                    display: 'none',
                                },
                                '&.Mui-focused:has(div[aria-expanded="false"])': {
                                    fieldset: {
                                        display: 'block',
                                    },
                                },
                                '.MuiSelect-select': {
                                    padding: '8px',
                                    paddingRight: '24px !important',
                                },
                                svg: {
                                    right: 0,
                                },
                            }}
                            value={country.iso2}
                            onChange={(e) => setCountry(e.target.value as CountryIso2)}
                            renderValue={(value) => (
                                <FlagImage iso2={value} style={{ display: 'flex' }} />
                            )}
                        >
                            {defaultCountries.map((c) => {
                                const country = parseCountry(c);
                                return (
                                    <MenuItem key={country.iso2} value={country.iso2}>
                                        <FlagImage
                                            iso2={country.iso2}
                                            style={{ marginRight: '8px' }}
                                        />
                                        <Typography marginRight="8px">{country.name}</Typography>
                                        <Typography color="gray">+{country.dialCode}</Typography>
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </InputAdornment>
                },
            }}
            {...restProps}
        />
    );
};

const UmbrellaSignUp = () => {
    const [showPassword, setShowPassword] = React.useState(false);
    const [value, setValue] = React.useState(0);
    const [phone, setPhone] = useState('');

    const handlePhoneChange = (value: string) => {
        setPhone(value);
    };

    const BpIcon = styled('span')(({ theme }) => ({
        borderRadius: 4,
        width: 24,
        height: 24,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#fff',

        'input:hover ~ &': {
            border: '1px solid #666666',
        },
    }));

    const BpCheckedIcon = styled(BpIcon)({
        '&::before': {
            display: 'block',
            width: 24,
            height: 24,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fillRule='evenodd' clipRule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input ~ &': {
            backgroundColor: '#178EFC',
            border: 'none',
        },

        'input:hover ~ &': {
            border: 'none',
        }
    });

    function BpCheckbox(props: CheckboxProps) {
        return (
            <Checkbox
                sx={{ '&:hover': { bgcolor: 'transparent' } }}
                disableRipple
                color="default"
                checkedIcon={<BpCheckedIcon />}
                icon={<BpIcon />}
                {...props}
            />
        );
    }

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    }

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    return (
        <Box p={{ xs: "16px", sm: "20px", xl: "48px" }} sx={{ backgroundImage: `url(${umbrellaSignBg})`, backgroundColor: "#E6E6E6", minHeight: "100vh", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center" }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={{ xs: "20px", sm: "unset" }} position="sticky" top="24px" zIndex="2">
                <Box><img src={Logo} alt="logo" /></Box>
                <Button variant="text" sx={{
                    textTransform: "capitalize", color: "#111827 !important", fontSize: "16px", display: "flex", gap: "8px", "&:hover": {
                        boxShadow: "none!important",
                        borderRadius: "8px",
                        "& svg": {
                            transform: "translateX(2px)",
                            transition: "all 0.3s ease",
                        }
                    }
                }}>
                    Log in
                    <RightArrow />
                </Button>
            </Box>
            <Box p={{ xs: "20px", sm: "40px" }} display="flex" flexDirection="column" justifyContent="center" alignItems="center" boxShadow="5px 5px 10.9px 0px #0000001A" border="1px solid #E9E9E9" bgcolor="#FFFFFF" maxWidth="576px" margin="auto" borderRadius="24px" marginTop="40px">
                {value === 1 ? (
                    <>
                        <Typography
                            color="#060023"
                            fontWeight="700"
                            fontSize={{ xs: "30px", sm: "36px" }}
                            mb="24px"
                        >
                            Add payment details
                        </Typography>
                        <Typography color="#000000" fontSize="14px" fontWeight="500" mb="25px">Don’t worry! You won’t be charged till free trial ends.</Typography>
                    </>
                ) : (
                    <>
                        <Typography
                            color="#060023"
                            fontWeight="700"
                            fontSize={{ xs: "30px", sm: "36px" }}
                            mb="24px"
                        >
                            Start 14 days free trial
                        </Typography>
                        <Box display="flex" gap="19px" mb="24px" flexWrap="wrap">
                            <Typography
                                borderRight="1px solid #666666"
                                paddingRight="19px"
                                color="#666666"
                                fontSize="14px"
                            >
                                No Credit Card Required
                            </Typography>
                            <Typography
                                borderRight="1px solid #666666"
                                color="#666666"
                                paddingRight="19px"
                                fontSize="14px"
                            >
                                Easy to setup
                            </Typography>
                            <Typography color="#666666" paddingRight="19px" fontSize="14px">
                                Cancel any time
                            </Typography>
                        </Box>
                    </>
                )}

                <Box sx={{ width: '100%' }} className="umbrella-signIn-tabs">
                    <Box sx={{ display: "flex", justifyContent: "center", height: "4px" }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                            <Tab {...a11yProps(0)} sx={{
                                '& .MuiButtonBase-root.MuiTab-root.Mui-selected': {
                                    color: '#1D9652 !important',
                                },
                                '& .MuiTabs-indicator': {
                                    backgroundColor: '#1D9652 !important',
                                },
                            }} />
                            <Tab {...a11yProps(1)} />
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                        <Grid container rowSpacing={{ xs: 3, sm: 3, md: 3 }} columnSpacing={{ xs: 3, sm: 2, md: 3 }} mb="24px">
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    variant="outlined"
                                    placeholder='First name'
                                    label="First name"
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: '3px',
                                            borderColor: '#666666',
                                        },

                                        " .MuiInputLabel-root.Mui-focused": {
                                            color: "inherit",
                                        },

                                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                            borderColor: '#333333',
                                            border: '1px solid'
                                        },

                                        "& .MuiOutlinedInput-input": {
                                            padding: '14px 16px',
                                            background: '#ffffff',
                                            borderRadius: '8px'
                                        },
                                        "&.MuiInputBase-input::placeholder": {
                                            color: '#333333',
                                            fontSize: '16px',
                                            opacity: '0.8'
                                        },
                                    }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    variant="outlined"
                                    placeholder='Last name'
                                    label="Last name"
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: '3px',
                                            borderColor: '#666666',
                                        },

                                        " .MuiInputLabel-root.Mui-focused": {
                                            color: "inherit",
                                        },

                                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                            borderColor: '#333333',
                                            border: '1px solid'
                                        },

                                        "& .MuiOutlinedInput-input": {
                                            padding: '14px 16px',
                                            background: '#ffffff',
                                            borderRadius: '8px'
                                        },
                                        "&.MuiInputBase-input::placeholder": {
                                            color: '#333333',
                                            fontSize: '16px',
                                            opacity: '0.8'
                                        },
                                    }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                <TextField
                                    variant="outlined"
                                    placeholder='Email address'
                                    label="Email address"
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: '3px',
                                            borderColor: '#666666',
                                        },

                                        " .MuiInputLabel-root.Mui-focused": {
                                            color: "inherit",
                                        },

                                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                            borderColor: '#333333',
                                            border: '1px solid'
                                        },

                                        "& .MuiOutlinedInput-input": {
                                            padding: '14px 16px',
                                            background: '#ffffff',
                                            borderRadius: '8px'
                                        },
                                        "&.MuiInputBase-input::placeholder": {
                                            color: '#333333',
                                            fontSize: '16px',
                                            opacity: '0.8'
                                        },
                                    }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                <MuiPhone
                                    value={phone}
                                    onChange={handlePhoneChange}
                                    fullWidth
                                />
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                <TextField
                                    variant="outlined"
                                    label="Password"
                                    type={showPassword ? 'text' : 'password'}
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: '3px',
                                            borderColor: '#666666',
                                            background: '#ffffff',
                                            paddingRight: '0'
                                        },

                                        " .MuiInputLabel-root.Mui-focused": {
                                            color: "inherit",
                                        },

                                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                            borderColor: '#333333',
                                            border: '1px solid'
                                        },

                                        "& .MuiOutlinedInput-input": {
                                            padding: '14px 16px',
                                            background: '#ffffff',
                                            borderRadius: '8px'
                                        },
                                        "&.MuiInputBase-input::placeholder": {
                                            color: '#333333',
                                            fontSize: '16px',
                                            opacity: '0.8'
                                        },
                                    }}
                                    slotProps={{
                                        input: {
                                            endAdornment: <InputAdornment position="start"><IconButton onClick={handleClickShowPassword}
                                                sx={{ borderRadius: "2px", "&:hover": { backgroundColor: "unset" } }}
                                                onMouseDown={handleMouseDownPassword}
                                                onMouseUp={handleMouseUpPassword}  >
                                                {!showPassword ? <Box display="flex" gap="4px" alignItems="center" color="#000000"><VisibilityIcon fontSize='small' />
                                                    <Typography component="span" color="#000000" fontSize="14px">Show</Typography></Box>
                                                    : <Box display="flex" gap="4px" alignItems="center" color="#000000">
                                                        <VisibilityOffIcon fontSize='small'></VisibilityOffIcon> <Typography component="span" fontSize="14px">hide</Typography></Box>
                                                }
                                            </IconButton>
                                            </InputAdornment>
                                        },
                                    }}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                        <Button variant="contained" disableElevation sx={{ display: "flex", alignItems: "center", justifyContent: "center", textTransform: "capitalize", width: "100%", height: "51px", gap: "8px", fontSize: "16px", fontWeight: "500", bgcolor: "#178EFC !important", "&:hover": { bgcolor: "#1171cbf7 !important" } }}>
                            Sign up
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_15809_100515)">
                                    <path d="M6.5 3.9375L11.5 8.9375L6.5 13.9375" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_15809_100515">
                                        <rect width="16" height="16" fill="white" transform="translate(0.5 0.9375)" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </Button>

                        <Box display="flex" alignItems="flex-start" flexDirection="column" mt="24px" width="100%">
                            <Typography color='#000000' fontSize='15px' marginBottom="16px">Signup using</Typography>
                            <Box display="flex">
                                <Box height="50px" width="50px" borderRadius="8px" display="flex" alignItems="center" justifyContent="center" border="1px solid #D9D9D9" bgcolor="#D9D9D9" mr="10px" sx={{ cursor: "pointer" }}>
                                    <img src={mail} />
                                </Box>
                                <Box height="50px" width="50px" borderRadius="8px" display="flex" alignItems="center" justifyContent="center" border="1px solid #D9D9D9" bgcolor="#0B66C3" mr="10px" sx={{ cursor: "pointer" }}>
                                    <img src={linkdin} />
                                </Box>
                                <Box height="50px" width="50px" borderRadius="8px" display="flex" alignItems="center" justifyContent="center" border="1px solid #D9D9D9" bgcolor="#000000" mr="10px" sx={{ cursor: "pointer" }}>
                                    <img src={microsoft} />
                                </Box>
                                <Box height="50px" width="50px" borderRadius="8px" display="flex" alignItems="center" justifyContent="center" border="1px solid #D9D9D9" bgcolor="#006AF7" mr="10px" sx={{ cursor: "pointer" }}>
                                    <img src={fb} />
                                </Box>
                            </Box>
                        </Box>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        <Typography color="#2B2B30" fontSize="18px" fontWeight="600" marginBottom="25px" textAlign="center">Free Trial plan</Typography>
                        <Box mb="25px">
                            <Typography color="#232323" fontSize="14px" mb="8px">Lets get Started! Your Domain URL is:</Typography>
                            <Typography color="#2B2B30" fontSize="18px" mb="8px" fontWeight="600" >ryanlee.easywebinar.live</Typography>
                            <Link
                                href="#"
                                sx={{
                                    color: "#1D9652",
                                    fontSize: "14px",
                                    fontWeight: 500,
                                    textDecoration: "none",
                                    fontFamily: "Roboto",

                                }}
                            >
                                Edit domain URL
                            </Link>
                            <Box marginTop="25px">
                                <FormControlLabel
                                    sx={{
                                        fontSize: "14px",
                                        color: "#333333",
                                    }}
                                    control={
                                        <BpCheckbox sx={{
                                            '& + span': {
                                                ml: '3px'
                                            }
                                        }} />
                                    }
                                    label={
                                        <Typography fontWeight="500" color="#707070" fontSize="14px">
                                            “I have read and agreed to the
                                            <Typography display="inline" color="#22B060" fontSize="14px">
                                                &nbsp;terms and services
                                            </Typography>”
                                        </Typography>
                                    }
                                />
                            </Box>
                        </Box>
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <Button variant="contained" disableElevation sx={{ display: "flex", alignItems: "center", justifyContent: "center", textTransform: "capitalize", px: "64px", height: "51px", gap: "8px", fontSize: "16px", fontWeight: "500", bgcolor: "#178EFC !important", "&:hover": { bgcolor: "#1171cbf7 !important" } }}>
                                Get Started
                            </Button>
                        </Box>
                    </CustomTabPanel>
                </Box>
            </Box >
            {value === 1 ? (
                <Box className="login-authenticator-wrapper" sx={{ position: "unset!important" }}>
                    <Box
                        className="ew-copyright"
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: { xs: "20px", md: "unset" },
                            justifyContent: { xs: "center" },
                            alignItems: 'center',
                            padding: '0 !important',
                            position: 'unset!important',
                            margin: '13px!important',
                        }}
                    >
                        <Typography
                            component="span"
                            sx={{ paddingRight: "13px !important", fontWeight: "500" }}
                        >
                            &copy; 2024 All Rights Reserved
                        </Typography>
                        <Box
                            component="ul"
                            sx={{
                                display: 'flex',
                                listStyle: 'none',
                                margin: 0,
                                padding: 0,
                                gap: '4px',
                                position: 'relative',
                            }}
                        >
                            <Box
                                component="li"
                            >
                                <Link
                                    href="#"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className='terms'
                                    sx={{
                                        textDecoration: 'none',
                                        color: '#1D9652',
                                        fontSize: '14px',
                                        fontWeight: "500",
                                        marginRight: "4px",
                                        '&:hover': {
                                            textDecoration: 'underline',
                                        },

                                    }}
                                >
                                    Terms of Service
                                </Link>
                            </Box>
                            <Box
                                component="li"
                            >
                                <Link
                                    href="#"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{
                                        textDecoration: 'none',
                                        color: '#1D9652',
                                        fontSize: '14px',
                                        fontWeight: "500",
                                        marginRight: "4px",
                                        '&:hover': {
                                            textDecoration: 'underline',
                                        },
                                    }}
                                >
                                    Privacy Policy
                                </Link>
                            </Box>
                            <Box
                                component="li"
                            >
                                <Link
                                    href="#"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{
                                        textDecoration: 'none',
                                        fontWeight: "500",
                                        '&:hover': {
                                            textDecoration: 'underline',
                                        },
                                    }}
                                >
                                    Security
                                </Link>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            ) : (
                <>
                </>
            )}
        </Box >
    )
}
export default UmbrellaSignUp
